module.exports = __webpack_public_path__ + "static/media/BANKNIFTY.5f912f08.txt";